import { useCallback } from 'react';
import { TagColorEnum } from 'packages/cosell/src/types/enums';
import Tag from 'packages/cosell/src/components/Tag/Tag';
import { makeStyles } from 'vendor/material';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5),
  },
}));

const incentiveMap = {
  'MSFT Internal Azure IP Co-Sell': 'IP Co-sell',
  'MACC (Customer)': 'MACC',
} as const;

const SolutionIncentiveTags = ({ incentives }: { incentives: string[] }) => {
  const classes = useStyles();
  const getIncentiveLabel = useCallback(
    (incentive: typeof incentives[number]) => {
      return incentive in incentiveMap ? incentiveMap[incentive] : incentive;
    },
    [],
  );

  return (
    <div className={classes.container}>
      {incentives.map((incentive) => {
        const label = getIncentiveLabel(incentive);
        return (
          <Tag
            color={label === 'MACC' ? TagColorEnum.GREEN : undefined}
            key={incentive}
            fontSize={12}
          >
            {label}
          </Tag>
        );
      })}
    </div>
  );
};

export default SolutionIncentiveTags;
